<template>
  <v-menu
    bottom
    left
    offset-y
    origin="top right"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="mr-4"
        min-width="0"
        text
        v-if="notifications.length"
        v-bind="attrs"
        v-on="on"
        icon
      >
        <v-badge
          color="red"
          overlap
        >
          <template v-slot:badge>
            <span>{{notifications.length}}</span>
          </template>

          <v-icon>mdi-bell</v-icon>
        </v-badge>
      </v-btn>
      <v-btn
        class="mr-4"
        min-width="0"
        text
        v-else
        v-bind="attrs"
        v-on="on"
        icon
      >
        <v-icon>mdi-bell</v-icon>
      </v-btn>
    </template>
    <v-list nav dense rounded>
      <v-list-item-group
        color="primary"
      >                                
        <v-list-item
          v-for="(n, i) in notifications"
          :key="i"  
          v-on:click="showNews(n)"
        > 
          <v-list-item-icon class="icon-news">
            <v-icon
              color="red"
            >
              mdi-new-box
            </v-icon>
          </v-list-item-icon>

          <v-list-item-content v-on="on">
            <v-list-item-title v-if="!n.visto"><b>{{ n.title }}</b></v-list-item-title>
            <v-list-item-title v-else>{{ n.title }} </v-list-item-title>
          </v-list-item-content>   
        </v-list-item>          
      </v-list-item-group>

      <v-list-item v-if="notifications.length <= 0">
        <v-list-item-content>
          <v-icon
            large
            color="green darken-2"
          >
            mdi-checkbox-marked-circle
          </v-icon>                             
        </v-list-item-content>
      </v-list-item> 

      <v-list-item>
        <v-list-item-content>
          <v-btn
            x-small
            color="primary"
            outlined
            @click="navigateListNews"
          >
            Ver todas
          </v-btn>
        </v-list-item-content>
      </v-list-item> 
    </v-list>    
  </v-menu>    

</template>

<script>
  import {listNewsTen} from "@/api/api-news";

  export default {
    name: 'News',
    components: {
    },
    data: () => ({
      notifications: [],
      dialog: false,
      news: {
        title: '',
        content: '',
        id_mappa_update: null
      },
    }),
    created() {
      listNewsTen(this.$apiAuth.getAuthToken())
      .then((res) => {
        this.notifications = res.data.data          
      })
      .catch(() => {
        //
      }) 
    },
    mounted () {
      this.$watch(() => {
        return this.$appMng.showNews
      },(val) => {
        if (!val) {
          this.getNews()
        }
      })   
    },
    methods: {
      navigateListNews() {
        this.$router.push("/app/list-news")
      },
      showNews(item) {
        this.$appMng.setIdNews(item.id_mappa_update)
        this.$appMng.setTitleNews(item.title)
        this.$appMng.setContentNews(item.content)
        this.$appMng.setShowNews(true)
      },
      closeNews(){
        this.item = null
        this.isShowNews = false
      },
      getNews() {
        listNewsTen(this.$apiAuth.getAuthToken())
        .then((res) => {
          this.notifications = res.data.data          
        })
        .catch(() => {
          //
        })         
      }
    }    
  }
</script>


<style scoped>
  .icon-news {
    margin-right: 7px !important;
  }
</style>
